const main = {
  apiUrl: "https://api-sportdigital.spovizz.cloud.vigitalsolutions.com",
  frontendUrl: "https://sportdigital.spovizz.cloud.vigitalsolutions.com/frontend",
  videoUrl: "https://video.spovizz.com",
  client: "sportdigital_live",
};

const config = {
  ...main,
  testMode: false,
  appName: "Spo|Vizz",
  screenshotsUrl: `${main.apiUrl}/screenshots/[[TEMPLATE]]/[[UUID]]/[[TYPE]].jpg`,
  chatbox: {
    active: false,
  },
  refreshVideoInterval: 10000,
  dashboardTemplatesRefreshInterval: 5000,
  clientBodyClass: "app-opta app-sd",
};

export default config;
